/** @jsx jsx */
import PrescribedHours from "domain/master/labor/prescribedHours";
import { Column } from "react-table";
import { useMemo, useCallback, useState } from "react";
import { css, jsx } from "@emotion/core";
import { SubActionButton, SecondaryButton } from "components/atoms/Button";
import DataTable from "components/organismos/DataTable/DataTable";
import { deleteById } from "api/prescribedHours";
import FormContents from "components/atoms/Form/FormContents";
import useToastNotification from "hooks/useToastNotification";
import usePrescribedHoursList from "./hooks";
import SidebarTemplate from "components/templates/SidebarTemplate";
import IconLabelButton from "components/molecules/IconLabelButton";
import { useHistory } from "react-router-dom";
import FormSubmitArea from "components/atoms/Form/FormSubmitArea";
import productColor from "components/styles";
import Modal from "components/molecules/Modal";
import BlockUI from "components/molecules/BlockUi";
import FormPadding from "components/atoms/Form/FormPadding";
import FormHeader from "components/templates/FormHeader";
import FlexBoxItem from "components/atoms/FlexBoxItem";


const styles = {
filterSearch: css({
  marginLeft: '37px',
  marginBottom: '10px'
})
};
const TimeZonePage = () => {
  const history = useHistory();
  const { prescribedList, setPrescribedList, isLoading } = usePrescribedHoursList();
  
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [selectedPrescribed, setSelectedPrescribed] = useState(
    PrescribedHours.generateInitial()
  );
  const { successNotification, errorNotification } = useToastNotification();

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  const openConfirmModal = useCallback((prescribed: PrescribedHours) => {
    setConfirmModalOpen(true);
    setSelectedPrescribed(prescribed);
  }, []);

  const deletePrescribed = useCallback(() => {
    const companyCode = sessionStorage.getItem("loginUser.companyCode") || "";
    deleteById(companyCode, selectedPrescribed.workingHoursId)
      .then((response: any) => {
        setPrescribedList(
          prescribedList.filter(
            (prescribed) =>
              prescribed.workingHoursId !== selectedPrescribed.workingHoursId
          )
        );
        setConfirmModalOpen(false);
        successNotification("削除しました。");
      })
      .catch((error) => {
        setConfirmModalOpen(false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          const listErr = error.response.data.errors;
          let stringErr = "";
          listErr.map((element: any, index: any) => {
            stringErr += `${element.defaultMessage}\n`;
            return stringErr;
          });
          errorNotification(stringErr);
        } else {
          errorNotification("サーバー側でエラーが発生しました。");
        }
      });
  }, [
    errorNotification,
    prescribedList,
    selectedPrescribed.workingHoursId,
    setPrescribedList,
    successNotification,
  ]);
  const columns: Array<Column<PrescribedHours>> = useMemo(
    () => [
      {
        Header: () => null,
        id: "actionButton",
        disableSortBy: true,
        Cell: (cell: {
          row: { isExpanded: boolean; original: PrescribedHours };
          data: Array<PrescribedHours>;
        }) => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <FlexBoxItem width="36px">
              <SubActionButton
                action={0}
                text="編集"
                onClick={() => {
                  history.push(
                    `/masterWorkingHours/edit/${cell.row.original.workingHoursId}`
                  );
                }}
              />
              </FlexBoxItem>
              <FlexBoxItem width="36px" marginLeft='5px'>
                <SubActionButton action={1} text="削除" onClick={() => {openConfirmModal(cell.row.original)}} />
              </FlexBoxItem>
             
            </div>
            // <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end' }}>

            //   <Link to={`/masterWorkingHours/edit/${cell.row.original.workingHoursId}`}>
            //     <span
            //       style={{ marginLeft: '20px' }}
            //       onMouseEnter={() => setIsHoverEdit(true)}
            //       onMouseLeave={() => setIsHoverEdit(false)}
            //     >
            //       <Icon type="edit" color={isHoverEdit ? iconColor.grayhover : iconColor.gray} />
            //     </span>
            //   </Link>
            //   <Link to="#" onClick={() => { openConfirmModal(cell.row.original); }}>
            //     <span
            //       style={{ marginLeft: '20px', marginRight: '10px' }}
            //       onMouseEnter={() => setIsHoverDelete(true)}
            //       onMouseLeave={() => setIsHoverDelete(false)}
            //     >
            //       <Icon type="delete" color={isHoverDelete ? iconColor.grayhover : iconColor.gray} />
            //     </span>
            //   </Link>

            // </div>
          );
        },
      },
      {
        Header: "コード",
        accessor: "workingHoursPatternCode",
      },
      {
        Header: "パターン名",
        accessor: "workingHoursPatternName",
      },
    ],
    [openConfirmModal, history]
  );
  return (
    <SidebarTemplate> 
      <BlockUI blocking={isLoading}>
        <FormHeader title="所定労働時間マスタ" />
          <FormContents customStyle={css({ marginTop:'60px' })}>    
            <FormPadding customStyle={css({paddingLeft:'8px'})}>
              <IconLabelButton
                onClick={() => history.push("/masterWorkingHours/add")}
                iconType="addCircle"
                text="追加"
              />
               </FormPadding>
            <div
              css={css` 
                table th:nth-of-type(1) {
                  width: 84px; 
                }
              `}
            >
              <div 
                className="table-bordered table-padding" 
                style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '15px' }}
              >
                <DataTable
                  className="table-no-border-left-right"
                  classNameParrant="border-left-right"
                  minWidth="100%"
                  columns={columns}
                  data={prescribedList}
                  isGlobalFilter={true}
                />
              </div>
            </div>
            <Modal
              open={confirmModalOpen}
              closeHandler={closeConfirmModal}
              title="所定労働時間を削除"
              submitText="削除する"
              note="所定労働時間を削除します。よろしいですか？"
              onSubmit={deletePrescribed}
              typeSubmit="reject"
            />
          </FormContents>
      </BlockUI>
    </SidebarTemplate>
  );
};

export default TimeZonePage;
